// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const MORE = "Viac";
